import { createAsyncThunk } from "@reduxjs/toolkit";
import type {
  PasswordPolicyViewModel,
} from "../../../api/axcloud";
import {
  createContractTenantApi,
  isAxiosErrorProblemDetails,
} from "../../../api";
import type {
  AccessTokenArg,
  ResetAdministratorPasswordArgType,
  SecurityThunkConfig,
} from "./types";

/** パスワードポリシーを取得する */
export const resolvePasswordPolicy = createAsyncThunk<
  PasswordPolicyViewModel,
  AccessTokenArg,
  SecurityThunkConfig
>("security/resolvePasswordPolicy", async (arg, thunk) => {
  const api = createContractTenantApi(arg.accessToken);
  try {
    const response = await api.getPasswordPolicy();
    return response.data;
  } catch (error) {
    if (isAxiosErrorProblemDetails(error)) {
      return thunk.rejectWithValue(error.response!.data);
    }
    throw error;
  }
});

/** 管理者パスワードをリセットする */
export const resetAdministratorPassword = createAsyncThunk<
  void,
  ResetAdministratorPasswordArgType,
  SecurityThunkConfig
>("security/resetAdministratorPassword", async (arg, thunk) => {
  const api = createContractTenantApi(arg.accessToken);
  try {
    await api.resetAdministratorPassword({
      newPassword: arg.newPassword,
      newPasswordConfirmation: arg.newPasswordConfirmation,
    });
  } catch (error) {
    if (isAxiosErrorProblemDetails(error)) {
      return thunk.rejectWithValue(error.response!.data);
    }
    throw error;
  }
});
